import { render, staticRenderFns } from "./PacoteKitModal.vue?vue&type=template&id=5f861407&scoped=true"
import script from "./PacoteKitModal.vue?vue&type=script&lang=js"
export * from "./PacoteKitModal.vue?vue&type=script&lang=js"
import style0 from "./PacoteKitModal.vue?vue&type=style&index=0&id=5f861407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f861407",
  null
  
)

export default component.exports